import request from '@/util/request'

//获取支持的设备类型 
export function apiGetDeviceTypeList(){
	return request({
		url:`/maintain-s/operating/system/device/deviceType`,
		method:"get"
	});
}

//获取某设备的列表 
export function apiGetDeviceList(type,param){
	return request({
		url:`/maintain-s/operating/system/device/${type}/list`,
		method:"get",
		params:param
	});
}



// WEBPACK FOOTER //
// ./src/api/maintain/device/main.js